export const VDJ_CACHE_ENABLED_KEY = 'vdjCacheEnabled';

export type VdjCacheIndexState = 'idle' | 'indexing' | 'ready' | 'error';

export interface VdjCacheIndexStatus {
  state: VdjCacheIndexState;
  processed: number;
  total: number | null;
  count: number;
  error?: string;
}

export function isVdjCacheEnabled(): boolean {
  try {
    return localStorage.getItem(VDJ_CACHE_ENABLED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function persistVdjCacheEnabled(enabled: boolean): void {
  localStorage.setItem(VDJ_CACHE_ENABLED_KEY, enabled ? 'true' : 'false');
}

/** True only after a full index exists; matching must not wait on this. */
export function vdjCacheMatchesAreLive(
  status: VdjCacheIndexStatus | null,
): boolean {
  return status?.state === 'ready';
}

export function describeVdjCacheIndex(
  enabled: boolean,
  status: VdjCacheIndexStatus | null,
): string {
  if (!enabled) {
    return '';
  }

  if (!status || status.state === 'idle') {
    return 'VirtualDJ cache matches will start showing after indexing finishes. You can keep using the app in the meantime.';
  }

  if (status.state === 'indexing') {
    const progress =
      status.total && status.total > 0
        ? ` ${status.processed.toLocaleString()} of ${status.total.toLocaleString()}.`
        : status.processed > 0
          ? ` ${status.processed.toLocaleString()} files so far.`
          : '';
    return `Indexing VirtualDJ cache.${progress} Matches from cache will start showing when this finishes — you can keep using the app.`;
  }

  if (status.state === 'error') {
    return `Could not index VirtualDJ cache${status.error ? `: ${status.error}` : ''}. Library matching still works.`;
  }

  const count =
    status.count > 0
      ? ` ${status.count.toLocaleString()} cache tracks can appear as match results.`
      : ' No cache tracks were found.';
  return `VirtualDJ cache is ready.${count}`;
}
